export function getAppSubdomain() {
  const currentDomain = window.location.host
  if (process.env.REACT_APP_TARGET === 'app') {
    return currentDomain
  }
  if (currentDomain.endsWith('.web.app')) {
    return currentDomain.replace('.web.app', '-app.web.app')
  }
  if (currentDomain.endsWith('.firebaseapp.com')) {
    return currentDomain.replace('.firebaseapp.com', '-app.firebaseapp.com')
  }
  if (currentDomain.startsWith('localhost')) {
    return `localhost:${process.env.REACT_APP_APP_DOMAIN_HOST}`
  }
  return 'app.' + currentDomain
}
